var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%","border-radius":"10px","background-color":"white","position":"relative"},attrs:{"id":"map"}},[_c('div',{staticStyle:{"position":"absolute","top":"8px","left":"8px","color":"#333333","font-size":"18px","font-weight":"bold"}},[_vm._v("设备地区分布（前五省）")])])
}]

export { render, staticRenderFns }